module.exports = __webpack_public_path__ + "img/esports-dark.3ac4d7f4.svg";